import React from 'react';
import WebsiteLayout from './WebsiteLayout';
import Team from './components/team';
import Research from './components/research';

const RoboticsTeam = () => {

    return(
        <WebsiteLayout>
            <Team/>
            <Research/>


        </WebsiteLayout>
        
    );



}

export default RoboticsTeam;



